const tickerItems = [
  "「抱木桩原地转圈大赛」今天开锣",
  "狗狗遛主人的迷惑现场冲上热榜",
  "大爷金鸡独立拉二胡全网破防",
  "搬砖姿势大赛冠军用两根手指封神",
  "乡村独轮车拉菜大赛热血开跑",
  "雨伞鞋发明让网友集体沉默",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* decorative shapes */}
      <div className="pointer-events-none absolute -left-16 top-10 h-64 w-64 rounded-full bg-primary-100/70 blur-2xl" />
      <div className="pointer-events-none absolute -right-10 top-40 h-72 w-72 rounded-full bg-accent-100/70 blur-2xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-52 w-52 rounded-full bg-secondary-100/80 blur-2xl" />

      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 pb-12 pt-28 md:px-6 md:pt-32 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12">
        {/* left copy */}
        <div className="w-full">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-emotion-laugh-line" />
            全网沙雕比赛合集 · 每天更新
          </span>
          <h1 className="mt-6 text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
            奇葩赛事天天有
            <br />
            今天我们替你把<span className="text-primary-600">笑点</span>包圆
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
            每日大赛为你盘点沙雕比赛合集、奇葩赛事盘点、民间高手过招、迷惑行为大赏、土味比赛现场。把离谱当乐趣，把沙雕当日常，每天几分钟，吃瓜解压两不误。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#daily"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-video-line" />
              围观今日赛报
            </a>
            <a
              href="#rank"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3 text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-fire-line" />
              看看热榜
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {[
              { num: "366", label: "全年每日上新" },
              { num: "5 大", label: "赛事栏目" },
              { num: "1200w", label: "全网每日围观" },
            ].map((item) => (
              <div key={item.label}>
                <dt className="sr-only">{item.label}</dt>
                <dd className="text-2xl font-extrabold text-foreground-900 md:text-3xl">{item.num}</dd>
                <p className="mt-1 text-xs text-foreground-600 md:text-sm">{item.label}</p>
              </div>
            ))}
          </dl>
        </div>

        {/* right visual */}
        <div className="relative w-full">
          <div className="grid grid-cols-2 gap-3">
            <img
              src="https://readdy.ai/api/search-image?query=playful%20confetti%20scene%20of%20a%20jumping%20contestant%20holding%20a%20giant%20golden%20trophy%20with%20a%20silly%20happy%20face%2C%20warm%20coral%20cream%20and%20teal%20color%20palette%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20solid%20background%2C%20playful%20editorial%20illustration%20style%2C%20high%20detail&width=800&height=900&seq=hero-fun-01&orientation=portrait"
              alt="拿着巨大奖杯开心跳跃的参赛选手"
              className="h-72 w-full rounded-3xl object-cover object-top md:h-80"
            />
            <img
              src="https://readdy.ai/api/search-image?query=cheerful%20crowd%20throwing%20pillows%20and%20confetti%20at%20a%20silly%20fun%20competition%2C%20warm%20coral%20and%20cream%20tones%20with%20teal%20accents%2C%20joyful%20energetic%20mood%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20background%2C%20playful%20editorial%20photography%20style%2C%20high%20detail&width=800&height=900&seq=hero-fun-02&orientation=portrait"
              alt="快乐的人群在趣味比赛现场抛枕头和彩带"
              className="mt-6 h-72 w-full rounded-3xl object-cover object-top md:h-80"
            />
          </div>

          <div className="absolute -right-2 top-3 flex items-center gap-2 rounded-2xl bg-foreground-900 px-4 py-2.5 text-background-50 shadow-sm md:right-4">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500">
              <i className="ri-fire-fill text-background-50" />
            </span>
            <div className="leading-tight">
              <p className="text-sm font-bold">今日热梗</p>
              <p className="text-[11px] text-background-200">狗狗遛主人 · 224 万围观</p>
            </div>
          </div>

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 rounded-full bg-background-50/90 px-4 py-2 text-xs font-medium text-foreground-700 shadow-sm backdrop-blur">
            <i className="mr-1 text-primary-500 ri-verified-badge-fill" />
            已累计收录 500+ 沙雕赛事
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="relative border-y border-background-200 bg-secondary-50/70">
        <div className="flex items-center gap-3 overflow-hidden">
          <span className="z-10 flex shrink-0 items-center gap-2 rounded-full bg-secondary-500 px-4 py-1.5 text-xs font-bold text-background-50 md:ml-2">
            <i className="ri-live-line" />
            实时上新
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-10 py-3">
              {[...tickerItems, ...tickerItems, ...tickerItems].map((item, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700">
                  <i className="text-primary-500 ri-magic-line" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}